<script setup>
import { useI18n } from 'vue-i18n';
import { onKeyStroke } from '@vueuse/core';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  entry: {
    type: Object,
    required: true,
  },
  text: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close', 'restore']);
const { t } = useI18n();

onKeyStroke('Escape', () => emit('close'));
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-50 flex flex-col bg-n-solid-1 p-4 md:p-8"
      role="dialog"
      aria-modal="true"
    >
      <div class="mx-auto flex h-full w-full max-w-4xl flex-col">
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <p class="font-medium text-n-slate-12">
              {{ props.entry.userName }}
            </p>
            <time class="text-sm text-n-slate-11">
              {{ new Date(props.entry.createdAt).toLocaleString() }}
            </time>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <Button
              v-if="props.text"
              :label="t('ARROWS_AI.HISTORY.RESTORE')"
              variant="faded"
              color="slate"
              size="sm"
              icon="i-lucide-undo-2"
              @click="emit('restore')"
            />
            <Button
              :label="t('ARROWS_AI.HISTORY.CLOSE')"
              variant="faded"
              color="slate"
              size="sm"
              icon="i-lucide-minimize-2"
              @click="emit('close')"
            />
          </div>
        </div>
        <div class="mt-6 min-h-0 flex-1 overflow-y-auto">
          <p class="whitespace-pre-wrap text-sm text-n-slate-12">
            {{ props.text }}
          </p>
        </div>
      </div>
    </div>
  </Teleport>
</template>
